module.exports = __webpack_public_path__ + "static/media/mr-bharat.fe210ca6.png";